import {AnimatePresence, motion} from 'framer-motion'

// css
import './css/slidecomponent.css'
import './css/slide0.css'

//images
import RoundedMe from '../images/static/RoundedMe.png'


const Slide_0 = ({ counter }) => { 
	return(
		<AnimatePresence>
			{counter === 0 &&
			<motion.div 
				key="slide_components_key0"
				initial={{opacity:0}}
				animate={{opacity:1}}
				transition={{duration:1}}
				exit={{opacity:0}}				
				id="slide_components_0"
				className="slide_components">
				<div className="slide_0_content">
					<AnimatePresence>
						<motion.p
							key="slide_components0p0"
							initial={{opacity:0}}
							animate={{opacity:1}}
							transition={{duration:1, delay:.8}}
							exite={{opacity:0}}
						>I am Yassine</motion.p>
						<br/>
						<motion.p
							key="slide_components0p1"
							initial={{opacity:0}}
							animate={{opacity:1}}
							transition={{duration:1, delay:1}}
							exite={{opacity:0}}
						>
							I’m a web developer. I spend my whole day,
							 practically every day, experimenting with 
							 HTML, CSS, and JavaScript  
						</motion.p>
						<br/>
						<motion.p
							key="slide_components0p2"
							initial={{opacity:0}}
							animate={{opacity:1}}
							transition={{duration:1, delay:1.2}}
							exite={{opacity:0}}
						>
							  Also experimenting with React and Express; and inhaling a wide variety of
							  potentially useless information through a 
							  articles & forumes. I build a professional websites 
							  that delivers a unique experience to the visitor.
						</motion.p>
					</AnimatePresence>
				</div>

				<div className="pic_parent">
					<AnimatePresence>
						<motion.div 
								key="pic_parent_innerwrapper_Key0"
								initial={{height:0}}
								animate={{height:"auto"}}
								transition={{duration:1}}
								className="pic_parent_innerwrapper">
							<div className="my_pic_container">
								<img src={RoundedMe} alt='' />
							</div>

								<ul id="home_icons_for_pic" key="dzqdqzd">
							<AnimatePresence>
									<motion.li
										key="home_li_Key3"
										initial={{opacity:0, y:10}}
										animate={{opacity:1, y:0}}
										transition={{duration:1, delay:1}}
										exit={{opacity:0, y:-10}}
									>
									<i className="fas fa-envelope-open"></i>
									<p>yassineUniversity@gmail.com</p></motion.li>									

									<motion.li
										key="home_li_Key2"
										initial={{opacity:0, y:10}}
										animate={{opacity:1, y:0}}
										transition={{duration:1, delay:1.5}}
										exit={{opacity:0, y:-10}}
									>
									<i className="fas fa-school"></i>
									<p>Grduated from university</p></motion.li>

									<motion.li
										key="home_li_Key0"
										initial={{opacity:0, y:10}}
										animate={{opacity:1, y:0}}
										transition={{duration:1, delay:2}}
										exit={{opacity:0, y:-10}}
									>
									<i className="fas fa-map-marker"></i>
									<p>Located in Algeria</p></motion.li>

									
							</AnimatePresence>
								</ul>
						</motion.div>
						<motion.ul className="slide_components_0_socials" key="pic_parent_innerwrapper_Key1">
							<AnimatePresence>
									<motion.li
										key="home_socials_Key0"
										initial={{opacity:0}}
										animate={{opacity:1}}
										transition={{duration:.5, delay:2}}
									><a href="/"><i className="fab fa-linkedin"></i></a></motion.li>
									
									<motion.li
										key="home_socials_Key1"
										initial={{opacity:0}}
										animate={{opacity:1}}
										transition={{duration:.5, delay:2.2}}
									><a href="/"><i className="fab fa-twitter"></i></a></motion.li>
									
									<motion.li
										key="home_socials_Key2"
										initial={{opacity:0}}
										animate={{opacity:1}}
										transition={{duration:.5, delay:2.3}}
									><a href="/"><i className="fab fa-github"></i></a></motion.li>
									
									<motion.li
										key="home_socials_Key3"
										initial={{opacity:0}}
										animate={{opacity:1}}
										transition={{duration:.5, delay:2.4}}
									><a href="/"><i className="fab fa-instagram"></i></a></motion.li>
									
									<motion.li
										key="home_socials_Key4"
										initial={{opacity:0}}
										animate={{opacity:1}}
										transition={{duration:.5, delay:2.5}}
									><a href="/"><i className="fab fa-facebook"></i></a></motion.li>
							</AnimatePresence>
						</motion.ul>
					</AnimatePresence>
				</div>
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_0